
import { useEffect } from 'react';
import type { Application } from '@/types/database.types';

interface ApplicationUnloadHandlerProps {
  application: Application | null;
  saveProgress: () => Promise<void>;
}

export const ApplicationUnloadHandler = ({ 
  application, 
  saveProgress 
}: ApplicationUnloadHandlerProps) => {
  // Save when navigating away from the application
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Save the current application data before navigating away
      if (application) {
        // We can't use async/await in beforeunload handler,
        // so we'll do a synchronous save attempt
        try {
          saveProgress();
        } catch (error) {
          console.error('Error saving on page unload:', error);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [application, saveProgress]);

  return null;
};
